import { createContext } from 'react'

export const SearchSelectContext = createContext({})
